import { OfflineStorage } from "./estrylib";

export const ResidenceAppointmentsTypesButtonsItems = [
  {
    id: 1,
    text: "First Time",
  },
  {
    id: 2,
    text: "Renewal",
  },
];
export const ResidenceAppointmentsVerificationButtonsItems = [
  {
    id: 1,
    text: "Email",
  },
  {
    id: 2,
    text: "Phone",
  },
];
export const ResidenceAppointmentTypes = [
  {
    label: window.sys_app_translate(
      "Tourism",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Tourism",
  },
  {
    label: window.sys_app_translate(
      "Family",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Family",
  },
  {
    label: window.sys_app_translate(
      "Student",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Student",
  },
  {
    label: window.sys_app_translate(
      "Long Term",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Long Term",
  },
];
